import { Component, OnInit, TemplateRef } from '@angular/core';

import { ArkUnitOfWork } from 'app/core/core.module';
import { InvolvementSkill } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import { confirm, alert } from 'devextreme/ui/dialog';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-skills',
    template: `
        <div class="page-content page-fill">
            <div class="row flex-fill">
                <div class="col-8 flex-fill border-end">
                    <div class="grid-fill">
                        <dx-data-grid
                            #grid
                            [dataSource]="skills"
                            keyExpr="id"
                            [showBorders]="true"
                            (onToolbarPreparing)="onToolbarPreparing($event)"
                        >
                            <dxi-column dataField="name"></dxi-column>
                            <dxi-column dataField="description"></dxi-column>

                            <div *dxTemplate="let data of 'toolbarButtons'">
                                <dx-button text="Add" type="default" (onClick)="edit(skillModal)"></dx-button>
                                <dx-button
                                    text="Edit"
                                    type="default"
                                    (onClick)="edit(skillModal, grid)"
                                    [disabled]="!grid.focusedRowKey"
                                ></dx-button>
                                <dx-button
                                    text="Delete"
                                    type="danger"
                                    (onClick)="delete(grid)"
                                    [disabled]="!grid.focusedRowKey"
                                ></dx-button>
                            </div>

                            <dxo-selection mode="single"></dxo-selection>
                            <dxo-search-panel [visible]="true"></dxo-search-panel>
                        </dx-data-grid>
                    </div>
                </div>
            </div>
        </div>

        <ng-template #skillModal>
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title pull-left">Skill</h4>
                </div>
                <div class="modal-body">
                    <dx-form [formData]="selectedSkill">
                        <dxi-item dataField="name"></dxi-item>
                        <dxi-item dataField="description"></dxi-item>
                    </dx-form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" (click)="saveDialog()">Save</button>
                    <button type="button" class="btn btn-default" (click)="closeDialog()">Cancel</button>
                </div>
            </div>
        </ng-template>
    `,
    styles: [],
    imports: [DevExtremeModule]
})
export class SkillsComponent implements OnInit {
    skills: InvolvementSkill[];
    selectedSkill: InvolvementSkill;
    onToolbarPreparing = SharedModule.onToolbarPreparing;

    constructor(private uow: ArkUnitOfWork, private modalService: BsModalService) {}

    async ngOnInit() {
        await this.getData();
    }

    private async getData() {
        this.skills = await this.uow.involvementSkills.all('name');
    }

    async edit(template: TemplateRef<any>, grid?: DxDataGridComponent) {
        this.selectedSkill = grid ?
            await grid.instance.byKey(grid.focusedRowKey)
            : this.uow.manager.createEntity('InvolvementSkill') as InvolvementSkill;
        this.editDialog(template);
    }

    async delete(grid: DxDataGridComponent) {
        this.selectedSkill = await grid.instance.byKey(grid.focusedRowKey);
        if (await confirm(`Are you sure you want to delete the "${this.selectedSkill.name}" skill?`, 'Delete Skill')) {
            this.selectedSkill.entityAspect.setDeleted();
            await this.uow.commit();
            this.selectedSkill = null;
            await this.getData();
        }
    }

    async editDialog(template: TemplateRef<any>, ) {
        const modalRef = this.modalService.show(template, { backdrop: 'static', class: 'modal-sm', focus: true });
        this.modalService.onHidden.subscribe(reason => {
            this.closeDialog();
        });
    }

    async saveDialog() {
        await this.uow.commit();
        await this.getData();
        this.closeDialog();
    }

    closeDialog() {
        this.uow.rollback();
        this.modalService.hide(1);
    }
}
